const routes = {
    HOME: "/",
    ABOUTUS: "/aboutus",
    SERVICES: "/services",
    PROJECTS: "/projects",
    CONTACTUS: "/contactus",
};

export default routes;
